import React from 'react';
import PropTypes from 'prop-types';
import * as rights from '../../../../model/rights';
import GenericRow from './GenericRow';

class ReservationRow extends GenericRow {
  constructor(props) {
    super(props);
  }

  render() {
    return <div className={'row col-md-12'}>
      <div className={'col-md-4'} style={{marginTop: '12px'}}>
        <div style={this.getColumnStyle()}>
          <span>RESERVATION</span>
        </div>
      </div>
      <div className={'col-md-8'}>
        {this.getTableDataContent(rights.RESERVATION_READ_PRIVILEGE)}
        {this.getTableDataContent(rights.RESERVATION_ADD_PRIVILEGE)}
        {this.getTableDataContent(rights.RESERVATION_EDIT_PRIVILEGE)}
        {this.getTableDataContent(rights.RESERVATION_DELETE_PRIVILEGE)}
        {this.getEmptyDataContent()}
        {this.getEmptyDataContent()}
      </div>
    </div>;
  }
}

ReservationRow.propTypes = {
  permissionSection: PropTypes.object,
  onChange: PropTypes.func,
};

export default ReservationRow;
